import { __assign, __rest } from "tslib";
import { configureScope as sentryConfigureScope, captureException as sentryCaptureException, init as sentryInit, } from "@sentry/browser";
export function init(conf) {
    var sentryDsn = conf.sentryDsn, opts = __rest(conf, ["sentryDsn"]);
    if (sentryDsn) {
        sentryInit(__assign({ dsn: sentryDsn }, opts));
    }
}
export function identify(user) {
    sentryConfigureScope(function (scope) {
        scope.setUser(user);
    });
}
export function captureException(error) {
    var _a;
    if (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) !== "production") {
        console.error(error);
    }
    return sentryCaptureException(error);
}
export { showReportDialog } from "@sentry/browser";
//# sourceMappingURL=index.js.map